import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import CalendarIcon from '@/public/images/dashboard/calendar.svg';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function VisitsToConfirmEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={CalendarIcon}
      title={Trans(
        translations,
        'HereYouWillSeeVisitsWaitingForYourConfirmation'
      )}
      description={Trans(
        translations,
        'ConfirmVisitsToKeepYourScheduleUpToDate'
      )}
    />
  );
}

export default VisitsToConfirmEmptyState;
